import { defineMessages } from 'react-intl';

export const notificationTypeMessages = {
  canReceiveOpportunityEmails: defineMessages({
    title: {
      id: 'notifications.opportunity-emails.title',
      defaultMessage: 'Opportunity emails',
    },
    description: {
      id: 'notifications.opportunity-emails.description',
      defaultMessage:
        'Select all locations for which you would like to receive emails about spot-adjustment opportunities. You will receive an email for each location.',
    },
  }),
  canReceiveReservationNotificationEmails: defineMessages({
    title: {
      id: 'notifications.reservations.title',
      defaultMessage: 'Reservations and cancellations email',
    },
    description: {
      id: 'notifications.reservations.description',
      defaultMessage:
        'Select all locations for which you would like to receive an email for every ClassPass reservation and cancellation.',
    },
  }),
  canReceiveRosterNotifications: defineMessages({
    title: {
      id: 'notifications.roster.title',
      defaultMessage: 'Daily roster email',
    },
    description: {
      id: 'notifications.roster.description',
      defaultMessage:
        'Select all locations for which you would like to receive a daily email in the morning listing all the reservations for that day. You will receive an email for each location.',
    },
  }),
  canReceiveSms: defineMessages({
    title: {
      id: 'notifications.sms.title',
      defaultMessage: 'SMS notifications',
    },
    description: {
      id: 'notifications.sms.description',
      defaultMessage: 'Select the location for which you would like to receive these texts:',
    },
    disclaimer: {
      id: 'notifications.sms.disclaimer',
      defaultMessage:
        'I agree to receive text messages about my ClassPass reservations and cancellations to the phone number below. Standard message and data rates may apply. Manage your opt-out preferences here or reply STOP to any text.',
    },
  }),
  canReceiveChangelogEmails: defineMessages({
    title: {
      id: 'notifications.changelog.title',
      defaultMessage: 'Daily changelog email',
    },
    description: {
      id: 'notifications.changelog.description',
      defaultMessage:
        "If AutoSync is applicable to you, you will see it turned on under 'Manage > Venue Pages > AutoSync'. If applicable, select all locations to receive an email for each location",
    },
  }),
  canReceiveDigestEmails: defineMessages({
    title: {
      id: 'notifications.digest.title',
      defaultMessage: 'Weekly digest email',
    },
    description: {
      id: 'notifications.digest.description',
      defaultMessage:
        'Select all locations you would like to see in the weekly digest email. You will get recommendations for each location',
    },
  }),
  canReceiveNoPricingOptionReservationEmails: defineMessages({
    title: {
      id: 'notifications.can-receive-pricing-option-reservation-emails.title',
      defaultMessage: 'Integration notice email',
    },
    description: {
      id: 'notifications.can-receive-pricing-option-reservation-emails.description',
      defaultMessage:
        'If you are an integrated venue, we may send you notifications about the status of reservations we have sent through your integration. If applicable, select all locations to receive an email for each location.',
    },
  }),
  canReceiveAttendanceInquiryEmails: defineMessages({
    title: {
      id: 'notifications.attendance-inquiry-emails.title',
      defaultMessage: 'Reservation management emails',
    },
    description: {
      id: 'notifications.attendance-inquiry-emails.description',
      defaultMessage:
        'Select all locations for which you would like to receive ClassPass member attendance, class occurrence, and other booking-related verification requests',
    },
  }),
};

const messages = defineMessages({
  phoneNumberInput: {
    id: 'notifications.phone-number-input',
    defaultMessage: 'Phone number',
  },
  title: {
    id: 'notifications.title',
    defaultMessage: 'Notifications',
  },
  submit: {
    id: 'notifications.submit',
    defaultMessage: 'Save',
  },
  selectAll: {
    id: 'notifications.select-all',
    defaultMessage: 'Select All',
  },
  allVenues: {
    id: 'notifications.sms.all-venues',
    defaultMessage: 'All venues',
  },
  selectVenue: {
    id: 'notifications.sms.select-venue',
    defaultMessage: 'Select a location',
  },
  tag: {
    id: 'notifications.opportunity-emails.tag',
    defaultMessage: '{venueName}{venueSubtitle, select, undefined {} other { ({venueSubtitle})}}',
  },
  loadError: {
    id: 'notifications.load.error',
    defaultMessage: 'There was a problem loading your notification settings.',
  },
  requiredTag: {
    id: 'notifications.required-tag',
    defaultMessage: 'Please select at least one venue.',
  },
  updateSuccess: {
    id: 'notifications.update.success',
    defaultMessage: 'Your notification settings have been updated.',
  },
  updateError: {
    id: 'notifications.update.error',
    defaultMessage: 'There was problem updating your notification settings.',
  },
});

export default messages;
